import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Link2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi, errMsg } from "@/lib/api";

export function ZoomcarImportDialog({ open, onOpenChange, onImported }) {
  const api = useApi();
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/import/zoomcar", { url });
      const m = r.data.import_meta;
      toast.success(`Imported ${m.photos_copied} of ${m.photos_found} photos${m.price_found ? " and the hourly price" : ""}. Review and save.`);
      setUrl("");
      onOpenChange(false);
      onImported(r.data);
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="zoomcar-import-dialog">
        <DialogHeader><DialogTitle>Import a car from Zoomcar</DialogTitle></DialogHeader>
        <form onSubmit={run} className="space-y-4">
          <p className="text-sm text-neutral-400">Open the car on zoomcar.com, copy the page link and paste it here. Name, specs, features, price and all photos fill the Add car form for you to review. Only import cars you own or have permission to list.</p>
          <label className="block text-xs text-neutral-400">Zoomcar car link
            <input required value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://www.zoomcar.com/in/bangalore/cars/…" data-testid="zoomcar-import-url"
              className="mt-1 w-full rounded-md border border-white/10 bg-[#0A0A0A] px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]" />
          </label>
          <button disabled={busy} data-testid="zoomcar-import-submit" className="flex w-full items-center justify-center gap-2 rounded-md bg-[#FF5A00] py-2.5 text-sm font-semibold text-white disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Link2 className="h-4 w-4" />}{busy ? "Importing details and photos…" : "Import car"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
